type Status = 'settled' | 'authorized' | 'declined' | 'cancelled' | undefined;

export class CardActivity {

    public id: string;
    public accountId: string;
    public cardId: string;
    public created: Date;
    public modified: Date;
    public category: string;
    public merchant: string;
    public amount: number;
    public currency: string;
    public name: string;
    public last4: string;
    public status: Status;
    public location: string;
    public reason: string;

    constructor(ob?: Partial<CardActivity>) {

        this.id = undefined;
        this.accountId = undefined;
        this.cardId = undefined;
        this.created = undefined;
        this.modified = undefined;
        this.category = undefined;
        this.merchant = undefined;
        this.amount = undefined;
        this.currency = undefined;
        this.name = undefined;
        this.last4 = undefined;
        this.status = undefined;
        this.location = undefined;
        this.reason = undefined;

        if (!ob) { return; }

        if (ob.id !== undefined) { this.id = ob.id; }
        if (ob.accountId !== undefined) { this.accountId = ob.accountId; }
        if (ob.cardId !== undefined) { this.cardId = ob.cardId; }
        if (ob.created !== undefined) { this.created = new Date(ob.created); }
        if (ob.modified !== undefined) { this.modified = new Date(ob.modified); }
        if (ob.category !== undefined) { this.category = ob.category; }
        if (ob.merchant !== undefined) { this.merchant = ob.merchant; }
        if (ob.amount !== undefined) { this.amount = ob.amount; }
        if (ob.currency !== undefined) { this.currency = ob.currency; }
        if (ob.name !== undefined) { this.name = ob.name; }
        if (ob.last4 !== undefined) { this.last4 = ob.last4; }
        if (ob.status !== undefined) { this.status = ob.status; }
        if (ob.location !== undefined) { this.location = ob.location; }
        if (ob.reason !== undefined) { this.reason = ob.reason; }
    }
}

